import axios from "axios";

import {
  ADD_MEDIA,
  GET_CONTENT,
  DELETE_MEDIA,
  CREATE_KEYWORD,
  CREATE_COPYRIGHT,
  GET_SUM_MEDIA_VIEWS,
  GET_INDEX_MEDIAS,
} from "actions/ActionTypes";
import { getApi, postApi, delApi } from "actions/SendActions";
import { fetchApi } from "actions/FetchActions";

import { formatHeaders } from "utils/Api";
import rootURL from "utils/RootURL";

/** ********* FETCH ********** */

export const fetchIndexMedias = (token, data) =>
  postApi({
    endpoint: "/api/media/v6/admin/index_medias",
    type: GET_INDEX_MEDIAS,
    item: "index_medias",
    token,
    data,
  });

export const fetchMedia = (uuid, token, callback) =>
  getApi({
    endpoint: `/api/media/v6/admin/medias/${uuid}`,
    type: GET_CONTENT,
    item: "media",
    token,
    callback,
  });

/** ********* PLAYLISTS/KEYWORDS/COPYRIGHTS ********** */

export const addMediaToPlaylist = (media_uuid, playlist_uuid, token) =>
  postApi({
    endpoint: "/api/user/v3/playlist/add_media",
    type: ADD_MEDIA,
    item: "media",
    token,
    data: {
      media_uuid,
      playlist_uuid,
    },
  });

export const deleteMediaToPlaylist = (media_uuid, playlist_uuid, token) =>
  delApi({
    endpoint: "/api/user/v3/playlist/delete_media",
    type: DELETE_MEDIA,
    item: "media",
    token,
    data: {
      media_uuid,
      playlist_uuid,
    },
  });

export const createCopyright = (data, token) =>
  postApi({
    endpoint: "/api/media/v5/admin/medias/copyrights",
    type: CREATE_COPYRIGHT,
    item: "metadatas",
    token,
    data,
  });

export const createKeyword = (data, token) =>
  postApi({
    endpoint: "/api/media/v4/admin/medias/keywords",
    type: CREATE_KEYWORD,
    item: "metadatas",
    token,
    data,
  });

/** ********* ANALYTICS ********** */

export const fetchMediaViewsExport = (
  startDateStr,
  endDateStr,
  language_uuid,
  token,
  projectSlug,
  type,
  callback,
  onError,
  t,
) => {
  axios({
    url: rootURL(
      `/api/editor_stats/v1/admin/content/${type}_media_views?period_start=${startDateStr}&period_end=${endDateStr}&lang=${language_uuid}&export`,
    ),
    method: "GET",
    headers: {
      ...formatHeaders(token, [
        {
          key: "xx-ok-project",
          value: projectSlug,
        },
      ]),
    },
  })
    .then((json) => {
      if (callback) callback(json);
    })
    .catch(() => {
      onError(t("error:genericError"));
    });
};
